import manusingcomputer from './Man-Using-Computer.png'
import sideimage from './sideimage.png'
import Rect1 from './Rect1.png'
import CottonCorp from './Cotton_corp_add.png'
import India from './India.png'
import Contact from './Contact.png'
import profile_tools from './profile_tools.png'
import profile_tools1 from './profile_tools_1.png'
import Live from './Live.png'
import logo from './logo copy.png'
import barely from './bareliy.jpg'
import reciept_header from './Receipt-Header.png'
import footer_with_signatory_line from './Footer-with-Signatory-Line.png'
import login_side_img from './Login-Side-img.png'
import dashboard_img from './Dashboard-img.png'
import barely_black_bg_img from './Bareliy_Black_bg-img.png'
import Applied_Ministry from './Applied_Ministry.jpg'
import dashboard_bg_1 from './1.png'
import active_tenders from './Active-Tenders.png'
import DeactiveTenders from './Deactive-Tenders.png'
import Footer_img from './Footer.png'
import whatsapp from './WhatsApp.png'
import email from './Email.png'
import img1 from '../AboutUsImages/img1.png'
import img2 from '../AboutUsImages/img2.png'
import user1 from '../AboutUsImages/User1.png'
import user2 from '../AboutUsImages/User2.png'
import user3 from '../AboutUsImages/User3.png'
import aboutusbg from '../AboutUsImages/About-us-bg-img.png'
import ourteam from '../AboutUsImages/Our-Team.png'
import contactusbg from '../ContactUsImages/Contact-us-bg-img.png'
import location from '../ContactUsImages/Location.png'
import contact from '../ContactUsImages/Contact.png'
import email1 from '../ContactUsImages/Email.png'
import mayor1 from '../AboutUsImages/mayor-bareilly.jpg'
import mayor2 from '../AboutUsImages/municapal-bareilly.jpg'
import logout from '../LoginImages/Logout.png'
import Graph64 from './Graph-64.png'
import MoreMenu64 from './More-Menu-64.png'
import NewTasks64 from './New-Tasks-64.png'
import Spendthismonth64 from './Spendthismonth64.png'
import TotalProjects64 from './Total-Projects-64.png'
import Approved32 from './Approved-32.png'
import Disable32 from './Disable32.png'
import Error32 from './Error32.png'
import Click32 from './Click-32.png'
import Unclick32 from './Unclick-32.png'
import YourBalance from './Your-Balance.png'
import Sales from './Sales.png'
import Earnings from './Earnings.png'
import Earningss from './Earningss.png'
import Earningsss from './Earningsss.png'
import first from './11.png'
import Second from './2.png'
import third from './3.png'
import forth from './4.png'
import fifth from './5.png'
import Vadhavan from './Vadhavan.png'
import VadhavanLogin from './VadhavanLogin.png'
import submit from './submit.png'
import Cancel32 from './Cancel32.png'
import DeleteWhite32 from './Delete-White32.png'
import DeleteRed32 from './Delete-Red32.png'
import EditBlueBlue32 from './Edit-Blue-Blue32.png'
import EditWhite32 from './Edit-White32.png'
import Tax32 from './Tax32.png'
import UpdateWhite32 from './Update-White32.png'
import PhoneNumber32 from './Phone-Number32.png'
import Email32 from './Email32.png'
import video from './video.mp4'
import Adminimg from './AdminLogin.png'
import AdminLogo from './AdminLogo.png'
import AdminWhite from './AdminWhite.png'
import VadhvanLogo256 from './Vadhvan-Logo256.png'
import VadhvanLogo2561 from './Vadhvan-Logo25611.png'
import Profile from './Profile.png'
import True32 from './True32.png'
import navimg from './nav.png'
import BillApprovals32 from './Bill-Approvals32.png'
import Dashboard32 from './Dashboard32.png'
import EmployeeManagement32 from './Employee-Management32.png'
import MISReports32 from './MIS-Reports32.png'
import Master32 from './Master32.png'
import Report32 from './Report32.png'
import VendorManagement32 from './Vendor-Management 32.png'
import CreateDepartment32 from './Create-Department32.png'
import CreateEmployee32 from './Create-Employee32.png'
import CreateRole32 from './Create-Role32.png'
import EditViewEmp from './Edit,-View-Emp32.png'
import EditRoles32 from './Edit-Roles32.png'
import Rate from './Rate.png'
import UploadBill32 from './Upload-Bill32.png'
import Location32 from './Location32.png'
import Bank32 from './Bank-32.png'
import ECSFile from './ECSFile.png'
import BankofMaharashtraLogo256 from './Bank-of-Maharashtra-Logo256.png'
import AdminLogin1 from './AdminLogin1.png'
import Loginimg1 from './Login-img1.png'
import SingleUnifiedPortalLogo from './Single-Unified-Portal---LPRS-Logo.png'
import Contact32 from './Contact32.png'
import EmailS32 from './EmailS32.png'
import Time32 from './Time32.png'
import PRMLogowithwhitebg from './PRM-Logo-with-white-bg.png'
import Loginimg from './Login-img.png'
import SoftmateSystemsLogo from './Softmate-Systems-Final-Logo.png'
import AdminProfile100 from './Admin-Profile100.png'
import ContactUs32 from './Contact-Us32.png'
import Back32 from './Back32.png'
import ProposalCreation32 from './Proposal-Creation32.png'
import Loginimg11 from './Login-img.png'
import Password32 from './Password32.png'
import Username32 from './Username32.png'
import Loginimg123 from './Login-img123.png'
import TotalProjectCost from './Total-Project-Cost.png'
import AvailableBalance from './Available-Balance-in-Bank64.png'
import ExcessShortfall64 from './Excess,Shortfall64.png'
import UDDLOGO from './UDDLOGO.png'
import LRMS1 from './Liability-Registration-Management-System-LRMS-Logo1.png'
import LRMS from './Liability-Registration-Management-System-LRMS-Logo.png'
import TotalProjectCost11 from './Total-Project-Cost.png'
import TotalLimitAlloted from './Total-Limit-Alloted.png'
import TotalLimitAlloted123 from './TotalLimitAlloted123.png'
import TotalWorkOrders from './Total-Work-Orders.png'
import TotalAmountRelease from './Total-Amount-Release.png'
import TotalBillAmount64 from './Total-Bill-Amount64.png'
import TotalDeductionAmount64 from './Total-Deduction-Amount64.png'
import Edit32 from './Edit32.png'
import Delete32 from './Delete 32.png'
import SelectedDemandAmount from './Selected-Demand-Amount.png'
import AvailableReleaseAmount from './Available-Release-Amount.png'
import Balance from './Balance.png'
import ApprovePay32 from './Approve-&-Pay32.png'
import Search32 from './Search32.png'
import BillApprovalBlue32 from './Bill-Approval-Blue32.png'
import GRManagement32 from './GRManagement32.png'
import CreateGR from './Create GR-32.png'
import ViewGR from './View GR -32.png'
import ADDLimit32 from './Add Limit 32.png'
import LimitAllocation32 from './Limit-Allocation-32.png'
import GRApprovals32 from './GR-Approvals-32.png'
import GRDraftList32 from './GR-Draft-List-32.png'
import GROutwards32 from './GR-Outwards-32.png'
import LimitOutwards32 from './Limit-Outwards-32.png'
import LimitAllocationInwardListHeadwise32 from './Limit-Allocation-Inward-List-(Head-wise)-32.png'
import LimitAllocationInwardListProposalWise from './Limit-Allocation-Inward-List-(Proposal-Wise)-32.png'
import ProposalInwardStateWise32 from './Proposal Inward (State Wise) 32.png'
import DemandRequestInwardList32 from './Demand-Request-Inward-List-32.png'
import AdministrativApprovalOutward32 from './Administrative-Approval-Outward-32.png'
import DemandRequest32 from './Demand-Request-32.png'
import AdministrativeApprovalCreation64 from './Administrative-Approval-Creation-64.png'
import SingleUnifiedSystemLogo1 from './Single-Unified-System-Logo-Final.png'
import SingleUnifiedPortalLogo1 from './Single-Unified-Portal-Logo.png'



export { img1, img2, user1, user2, user3, aboutusbg, ourteam, contactusbg, location, contact, email1, whatsapp, email, Footer_img, DeactiveTenders, active_tenders, dashboard_bg_1, barely_black_bg_img, Applied_Ministry, dashboard_img, login_side_img, footer_with_signatory_line, reciept_header, barely, logo, Live, manusingcomputer, sideimage, Rect1, CottonCorp, India, Contact, profile_tools, profile_tools1, mayor1, mayor2, logout, Graph64, MoreMenu64, NewTasks64, TotalProjects64, Spendthismonth64, Approved32, Disable32, Error32, Click32, Unclick32, YourBalance, Sales, Earnings, Earningss, Earningsss, first, Second, third, forth, fifth, Vadhavan, VadhavanLogin, submit, Cancel32, Tax32, DeleteWhite32, DeleteRed32, EditWhite32, EditBlueBlue32, UpdateWhite32, PhoneNumber32, Email32, video, Adminimg, AdminLogo, AdminWhite, VadhvanLogo256, Profile, True32, navimg, BillApprovals32, Dashboard32, EmployeeManagement32, MISReports32, Master32, Report32, VendorManagement32, CreateDepartment32, CreateEmployee32, CreateRole32, EditViewEmp, EditRoles32, Rate, UploadBill32, Location32, Bank32, ECSFile, BankofMaharashtraLogo256, AdminLogin1, VadhvanLogo2561, Loginimg1, SingleUnifiedPortalLogo, Contact32, EmailS32, Time32, PRMLogowithwhitebg, Loginimg, SoftmateSystemsLogo, AdminProfile100, ContactUs32, Back32, ProposalCreation32, Loginimg11, Password32, Username32, Loginimg123, TotalProjectCost, AvailableBalance, ExcessShortfall64, UDDLOGO, LRMS1, LRMS, TotalProjectCost11, TotalLimitAlloted, TotalLimitAlloted123, TotalWorkOrders, TotalAmountRelease, TotalBillAmount64, TotalDeductionAmount64, Edit32, Delete32, SelectedDemandAmount, AvailableReleaseAmount, Balance, ApprovePay32, Search32, BillApprovalBlue32,GRManagement32,CreateGR,ViewGR, ADDLimit32,LimitAllocation32,GRApprovals32,GRDraftList32,LimitOutwards32,GROutwards32,LimitAllocationInwardListHeadwise32,LimitAllocationInwardListProposalWise,ProposalInwardStateWise32,DemandRequestInwardList32,AdministrativApprovalOutward32,AdministrativeApprovalCreation64,DemandRequest32,SingleUnifiedSystemLogo1,SingleUnifiedPortalLogo1}